import React, { useEffect, useRef } from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

const sayi = (n) => Number(n || 0).toLocaleString('tr-TR');
const AY_GENISLIK = 56;

const ArizaZamanCubuk = ({ seri, loading }) => {
  const kaydir = useRef(null);
  const noktalar = seri?.noktalar || [];

  useEffect(() => {
    const el = kaydir.current;
    if (el) el.scrollLeft = el.scrollWidth;
  }, [noktalar]);

  if (loading && noktalar.length === 0) {
    return <div className="ia-empty-inline"><i className="fas fa-spinner fa-spin" /> Yükleniyor</div>;
  }
  if (noktalar.length === 0) return null;

  return (
    <div className="ia-zaman-scroll" ref={kaydir}>
      <div className="ia-zaman" style={{ width: `max(100%, ${noktalar.length * AY_GENISLIK}px)` }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={noktalar} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" vertical={false} />
          <XAxis
            dataKey="etiket"
            tick={{ fontSize: 11, fill: '#94a3b8' }}
            interval={0}
            tickLine={false}
            axisLine={{ stroke: '#e2e8f0' }}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 11, fill: '#94a3b8' }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip
            cursor={{ fill: 'rgba(37,99,235,0.06)' }}
            contentStyle={{
              borderRadius: 10,
              border: '1px solid var(--border-color)',
              fontSize: 13,
            }}
            labelFormatter={(_l, payload) => payload?.[0]?.payload?.tam || _l}
            formatter={(v) => [sayi(v), 'Adet']}
          />
          <Bar dataKey="adet" fill="#2563eb" radius={[4, 4, 0, 0]} maxBarSize={28} />
        </BarChart>
      </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ArizaZamanCubuk;
